import { render, staticRenderFns } from "./DashboardSuperAdmin.vue?vue&type=template&id=ccb19faa"
import script from "./DashboardSuperAdmin.vue?vue&type=script&lang=js"
export * from "./DashboardSuperAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports